export function headingText(value: string) {
  return value.trim().replace(/\.$/, "");
}
